export const EX_DISPLAY_SUBTYPE = 'ExDisplay';
export const EX_DISPLAY_URL_HASH_ID = 'ex-display-info';
